import React, { useEffect, useState } from 'react';
import toast from '../libs/toast';

const ListRef = ({ refList }) => {
  const [tab, setTab] = useState(1);
  const [referrals, setReferrals] = useState([]);
  useEffect(() => {
    if (tab === 1) {
      setReferrals([...refList?.directly, ...[]]);
    } else {
      setReferrals([...refList?.indirectly, ...[]]);
    }
  }, [tab, refList]);
  
  return (
    <div>
      <div className="title-table-list">
        <p className="p-presale-body__ttl">LIST REFERRALS</p>

        <ul className="p-presale-head js-tab">
          <li
      
            className={`p-presale-head__item  ${tab === 1 ? 'active' : ''}`}
            onClick={() => setTab(1)}
          >
            <p style={{ padding: 7, textAlign: 'center' }}>Direct invitation</p>
          </li>
          <li
       
            className={`p-presale-head__item  ${tab === 2 ? 'active' : ''}`}
            onClick={() => setTab(2)}
          >
            <p style={{ padding: 7, textAlign: 'center' }}>Indirect invitation</p>
          </li>
        </ul>
      </div>

      <table className="rwd-table">
        <thead>
          <tr>
            <th style={{ borderRadius: '10px 0 0 0' }}>No.</th>
            <th>Friend</th>
            <th style={{ borderRadius: ' 0 10px 0 0 ' }}>BNB</th>
          </tr>
        </thead>
        <tbody>
          <>
            {referrals.length ? (
              referrals?.map((referral, index) => (
                <tr key={index}>
                  <td data-th="No.">{index + 1}</td>
                  <td data-th="Friend">{referral.address?.substring(0, 5) + '...' + referral.address?.slice(-4)}</td>
                  <td data-th="Point" className="p-presale-body__ttl" style={{ fontSize: 14 }}>
                    {' '}
                    {referral.amount.toFixed(4)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>Empty</td>
              </tr>
            )}
          </>
        </tbody>
      </table>
    </div>
  );
};

export default ListRef;
